import React from "react";
import rehypeReact from "rehype-react";
import { I18Link, UmLink } from "../components/i18link";
import { Address, Email, CompanyName } from "../components/social";


const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    // ul: ({ children, ...others }) => (
    //   <List bulleted {...others}>
    //     {children}
    //   </List>
    // ),
    // li: ({ children, ...others }) => (
    //   <List.Item {...others}>{children}</List.Item>
    // ),
    ilink: ({ children, ...others }) => (
      <I18Link {...others}>{children}</I18Link>
    ),
    umlink: ({ children, ...others }) => (
      <UmLink {...others}>{children}</UmLink>
    ),
    "social-address": Address,
    "social-email": Email,
    "company-name": CompanyName,
  },
  // components: { "my-component": MyComponent }
}).Compiler;

export default renderAst;
